import { ChangeDetectorRef, Component, OnInit, inject, input } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { LocaleService } from '../../services/locale/locale.service';
import type { JsonObject } from '../../domain/json.domain';

interface AnimationJsonModule {
  default: JsonObject;
}

@Component({
  selector: 'td-wb-svg-animation',
  templateUrl: 'svg-animation.component.html',
  styleUrls: ['svg-animation.component.scss'],
  imports: [
    LottieComponent
  ]
})
export class SvgAnimationComponent implements OnInit {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly localeService = inject(LocaleService);

  readonly animation = input<string>(undefined);
  readonly dimensions = input<{
    width: number;
    height: number;
}>(undefined);

  readonly loop = input<boolean>(false);
  styles: Partial<CSSStyleDeclaration>;
  options: AnimationOptions;

  ngOnInit(): void {
    import((`./animations-library/${this.animation()}-${this.localeService.getLanguage()}.json`)).then((animationData: AnimationJsonModule): void => {
      this.options = {
        animationData: animationData.default,
        loop: this.loop()
      };
      const dimensions = this.dimensions();
      this.styles = {
        width: dimensions ? `${dimensions.width}px` : '100%',
        height: dimensions ? `${dimensions.height}px` : '100%',
        maxWidth: dimensions ? `${dimensions.width}px` : '100%',
        maxHeight: dimensions ? `${dimensions.height}px` : '100%',
        margin: '0 auto'
      };
      this.changeDetectorRef.markForCheck();
    });
  }
}
